import React from 'react';
import { Check, Clock, Sparkles } from 'lucide-react';
import { lessons } from '../mock';

const Lessons = ({ onBook }) => {
  return (
    <section id="lessons" className="relative py-28 bg-[#0d0d0d]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-amber-400 tracking-[0.32em] text-[12px] mb-5 font-medium">LESSONS</p>
          <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Choose the lesson <span className="text-amber-400 italic">that fits you</span>
          </h2>
          <p className="mt-6 text-white/65 text-lg max-w-xl leading-relaxed">
            Flexible scheduling, transparent pricing, so you can
            see if we are a good fit before committing. Take your first step toward success with your first lesson.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {lessons.map((l) => (
            <div
              key={l.id}
              className={`relative rounded-2xl p-8 border transition-all duration-300 group ${
                l.popular
                  ? 'bg-gradient-to-b from-amber-400/10 to-transparent border-amber-400/50 hover:border-amber-400'
                  : 'bg-white/[0.02] border-white/10 hover:border-amber-400/40 hover:bg-white/[0.04]'
              }`}
            >
              {l.popular && (
                <div className="absolute -top-3 left-8 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-400 text-[#0a0a0a] text-xs font-semibold tracking-wide">
                  <Sparkles size={12} strokeWidth={2.5} /> MOST POPULAR
                </div>
              )}
              <h3 className="font-serif text-white text-3xl">{l.name}</h3>
              <div className="mt-3 flex items-center gap-2 text-white/55 text-sm">
                <Clock size={15} /> {l.duration}
              </div>
              <div className="mt-6 flex items-baseline gap-1">
                <span className="text-amber-400 text-5xl font-serif">{l.price}</span>
                <span className="text-amber-400/80 text-2xl font-serif">€</span>
                <span className="text-white/45 text-sm ml-1">/ session</span>
              </div>
              <p className="mt-5 text-white/65 text-[15px] leading-relaxed min-h-[80px]">
                {l.description}
              </p>
              <div className="mt-6 h-px bg-white/10" />
              <ul className="mt-6 space-y-3">
                {l.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-white/75 text-[14.5px]">
                    <Check size={16} className="text-amber-400 mt-0.5 shrink-0" strokeWidth={2.5} />
                    {f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => onBook(l.id)}
                className={`mt-8 w-full py-3.5 rounded-full text-[15px] font-medium transition-all duration-300 ${
                  l.popular
                    ? 'bg-amber-400 text-[#0a0a0a] hover:bg-amber-300'
                    : 'border border-amber-400/50 text-amber-400 hover:bg-amber-400 hover:text-[#0a0a0a]'
                }`}
              >
                Book this lesson
              </button>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center text-white/55 text-sm">
          <span className="text-amber-400">✓</span> Clear progress you can feel &nbsp;·&nbsp; <span className="text-amber-400">✓</span> Cancel anytime &nbsp;·&nbsp; <span className="text-amber-400">✓</span> Payment via PayPal or bank transfer
        </div>
      </div>
    </section>
  );
};

export default Lessons;
